// Thẻ số liệu dùng chung cho trang "Xu & Hạng": icon màu + số to + nhãn + so hôm qua bằng mũi tên.
// Cùng kiểu với thẻ ở trang Tổng quan / Tăng trưởng App (Card nhỏ, icon trong ô bo góc, số 2xl đậm).
import { Card, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-regular-svg-icons";
import { fmtNum } from "./xu-format-helpers";

/** ↑ xanh / ↓ đỏ + % so với số cũ. Số cũ = 0 mà số mới > 0 thì ghi "mới". */
export function DeltaBadge({ now, before, label = "so hôm qua" }) {
    const diff = (Number(now) || 0) - (Number(before) || 0);
    if (!diff) return <span className="text-xs text-gray-400">— bằng {label} ({fmtNum(before)})</span>;
    const up = diff > 0;
    const pct = before > 0 ? ` ${Math.round((Math.abs(diff) / before) * 100)}%` : " mới";
    return (
        <span className="text-xs font-medium" style={{ color: up ? "#16a34a" : "#dc2626" }}>
            {up ? "↑" : "↓"}{pct} <span className="font-normal text-gray-400">{label} ({fmtNum(before)})</span>
        </span>
    );
}

/**
 * @param {object} p
 * @param {object} p.icon     FontAwesome icon
 * @param {string} p.tone     tên màu tailwind: indigo | emerald | amber | cyan | purple | rose | slate
 * @param {string} p.title
 * @param {string|number} p.value  đã định dạng sẵn
 * @param {string} [p.unit]   đơn vị nhỏ cạnh số
 * @param {object} [p.delta]  { now, before } → hiện mũi tên so hôm qua
 * @param {string} [p.sub]    dòng phụ
 * @param {string} [p.help]   giải thích khi rê chuột vào dấu ?
 */
const TONES = {
    indigo: ["bg-indigo-50", "text-indigo-600"],
    emerald: ["bg-emerald-50", "text-emerald-600"],
    amber: ["bg-amber-50", "text-amber-600"],
    cyan: ["bg-cyan-50", "text-cyan-600"],
    purple: ["bg-purple-50", "text-purple-600"],
    rose: ["bg-rose-50", "text-rose-600"],
    slate: ["bg-slate-100", "text-slate-500"],
};

export default function XuKpiCard({ icon, tone = "indigo", title, value, unit, delta, sub, help, children }) {
    const [bg, fg] = TONES[tone] || TONES.indigo;
    return (
        <Card size="small" className="shadow-sm h-full">
            <div className="flex items-start gap-3">
                <div className={`${bg} rounded-xl p-3 shrink-0 w-11 h-11 flex items-center justify-center`}>
                    <FontAwesomeIcon icon={icon} className={fg} />
                </div>
                <div className="min-w-0 flex-1">
                    <div className="text-xs text-gray-500 flex items-center gap-1">
                        <span className="truncate">{title}</span>
                        {help && (
                            <Tooltip title={help}>
                                <FontAwesomeIcon icon={faCircleQuestion} className="text-gray-400 cursor-help" />
                            </Tooltip>
                        )}
                    </div>
                    <div className="text-2xl font-semibold leading-tight">
                        {value}
                        {unit && <span className="text-sm font-normal text-gray-400 ml-1">{unit}</span>}
                    </div>
                    {delta && <DeltaBadge now={delta.now} before={delta.before} />}
                    {sub && <div className="text-xs text-gray-400">{sub}</div>}
                    {children}
                </div>
            </div>
        </Card>
    );
}
